<span withLoadingSkeleton [isLoading]="isLoading()">
  @if (showLabels()) {
    <span class="label">lc</span>
  }
  <span class="value">{{ productId()?.lineCode }}</span>
  @if (showLabels()) {
    <span class="label">pn</span>
  }
  <span class="value">{{ productId()?.partNumber }}</span>
</span>
